/**
 * Single source of truth for avatar relationship options.
 * Used by CreateAvatarPage, RelationCaptureScreen, and any other UI
 * that presents a relationship dropdown.
 */
export const RELATION_OPTIONS = [
  { value: 'spouse',              label: 'Spouse' },
  { value: 'partner',             label: 'Partner' },
  { value: 'mother',              label: 'Mother' },
  { value: 'father',              label: 'Father' },
  { value: 'grandmother',         label: 'Grandmother' },
  { value: 'grandfather',         label: 'Grandfather' },
  { value: 'great_grandmother',   label: 'Great-Grandmother' },
  { value: 'great_grandfather',   label: 'Great-Grandfather' },
  { value: 'daughter',            label: 'Daughter' },
  { value: 'son',                 label: 'Son' },
  { value: 'granddaughter',       label: 'Granddaughter' },
  { value: 'grandson',            label: 'Grandson' },
  { value: 'great_granddaughter', label: 'Great-Granddaughter' },
  { value: 'great_grandson',      label: 'Great-Grandson' },
  { value: 'sister',              label: 'Sister' },
  { value: 'brother',             label: 'Brother' },
  { value: 'aunt',                label: 'Aunt' },
  { value: 'uncle',               label: 'Uncle' },
  { value: 'niece',               label: 'Niece' },
  { value: 'nephew',              label: 'Nephew' },
  { value: 'cousin',              label: 'Cousin' },
  { value: 'mother_in_law',       label: 'Mother-in-Law' },
  { value: 'father_in_law',       label: 'Father-in-Law' },
  { value: 'daughter_in_law',     label: 'Daughter-in-Law' },
  { value: 'son_in_law',          label: 'Son-in-Law' },
  { value: 'sister_in_law',       label: 'Sister-in-Law' },
  { value: 'brother_in_law',      label: 'Brother-in-Law' },
  { value: 'stepmother',          label: 'Stepmother' },
  { value: 'stepfather',          label: 'Stepfather' },
  { value: 'stepdaughter',        label: 'Stepdaughter' },
  { value: 'stepson',             label: 'Stepson' },
  { value: 'friend',              label: 'Friend' },
  { value: 'close_friend',        label: 'Close Friend' },
  { value: 'colleague',           label: 'Colleague' },
  { value: 'mentor',              label: 'Mentor' },
  { value: 'other',               label: 'Other' },
];
